// extracted by mini-css-extract-plugin
export var breadcrumbItem = "breadcrumbs-module--breadcrumbItem--1wM5f";
export var breadcrumbLink = "breadcrumbs-module--breadcrumbLink--L9Jei";
export var breadcrumbs = "breadcrumbs-module--breadcrumbs--rLjOu";
export var breadcrumbsList = "breadcrumbs-module--breadcrumbsList--gELSQ";